import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as AuthSelectors from './auth.selectors';
import * as AuthActions from './auth.actions';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/modules/auth/services/auth.service';

@Injectable()
export class AuthFacadeService {
    getLoginResult$ = this.store.select(AuthSelectors.getLoginResult);
    getGenerateOTPResult$ = this.store.select(AuthSelectors.getGenerateOTPResult);
    getVerifyOTPResult$ = this.store.select(AuthSelectors.getVerifyOTPResult);


    constructor(private store : Store, private authService : AuthService, private router : Router) {

    }

    login(data : any){
        this.store.dispatch(
            AuthActions.Login({data : data})
        )
    }

    generateOTP(mobileOrEmail : string, type : any){
        this.store.dispatch(
            AuthActions.GenerateOTP({mobileOrEmail : mobileOrEmail, userType : type})
        )
    }

    verifyOTP(mobileOrEmail : string, otp : string, type : any, ref_code:any){
        this.store.dispatch(
            AuthActions.VerifyOTP({phone : mobileOrEmail, otp : otp, userType : type, ref_code:ref_code})
        )
    }

    onOTPVerifySuccess(response : any){
        if ( response &&
            response.status
        ) {
            this.authService.setTokens(response);
            localStorage.setItem(
            'refreshToken',
            response.RefreshToken
            );
            //this.authService.startTokenUpdateTimer((response.ExpiresIn / 60) - 5);
            //this.router.navigateByUrl('/onboarding');
          this.router.navigateByUrl('/dashboard/invest');
        }
    }

    clearState(){
        this.store.dispatch(
            AuthActions.clearState()
        )
    }


}
